import React from 'react';
import styles from './NewSizeGuide.module.scss';
import { Image } from '../../atoms/image/Image';
import { InformationBlackIcon } from '../../atoms/icons';
import { Link } from '../../atoms/link/Link';
import clsx from 'clsx';
import { theme } from './_theme';

export const ProductTableBlock = ({ productData, sizeConversation }) => {
  const { productName, imageUrl, price, desc, table } = productData;
  const isWomen = sizeConversation === 'women';

  return (
    <div className={clsx(styles.titleBlock, {
      [styles.isSabaStyle]: theme === 'saba',
      [styles.isJagStyle]: theme === 'jag',
      [styles.isSCStyle]: theme === 'sportscraft',
    })}>
      <div className={styles.imageWrap}>
        <Image
          alt={productName}
          title={productName}
          itemProp="image"
          image={imageUrl?.url}
        />
        <div>
          <p className={styles.titleName}>{productName}</p>
          <p className={styles.titlePrice}>{price}</p>
          <p className={styles.textWrap} dangerouslySetInnerHTML={{ __html: desc }} />
        </div>
      </div>
      {(table?.size || table?.waist || table?.hip || table?.length || table?.bust) && (
        <div className={styles.productTableBlock}>
          <h4>Model measurements:</h4>
          <div className={styles.productTable}>
            {table?.size && (
              <div className={styles.tableItem}>
                <span>Size (AU)</span>
                <span>{table?.size}</span>
              </div>
            )}
            {table?.length && (
              <div className={styles.tableItem}>
                <span>Height (CM)</span>
                <span>{table?.length}</span>
              </div>
            )}
            {table?.bust && (
              <div className={styles.tableItem}>
                <span>{isWomen ? 'Bust (CM)' : 'Chest (CM)'}</span>
                <span>{table?.bust}</span>
              </div>
            )}
            {table?.waist && (
              <div className={styles.tableItem}>
                <span>Waist (CM)</span>
                <span>{table?.waist}</span>
              </div>
            )}
            {table?.hip && (
              <div className={styles.tableItem}>
                <span>Hip (CM)</span>
                <span>{table?.hip}</span>
              </div>
            )}
          </div>
        </div>
      )}

      <div className={styles.titleContactUsBlock}>
        <InformationBlackIcon />
        <p>
          For a more precise measurement please contact our&nbsp;
          <Link link="/help/contact-us">
            customer care team
          </Link>
        </p>
      </div>
    </div>
  )
};
